<template>
    <van-tabs class="data-cnt" v-model:active="tabActive" color="#07c160">
      <van-tab name="desc" title="数据说明">
        <article id="content" class="article-content" tabindex="0" style="outline-style: none;">
          <div class="ne-doc-major-viewer">
              <div class="yuque-doc-content" data-df="lake" style="position: relative;">
                  <div>
                      <div class="ne-viewer lakex-yuque-theme-light ne-typography-classic ne-paragraph-spacing-relax ne-viewer-layout-mode-fixed"
                           data-viewer-mode="normal" id="u5f1b">
                          <div class="ne-viewer-body">
                              <ne-oli index-type="0">
                                  <ne-oli-i><span class="ne-list-symbol" data-type="0" data-level="0"
                                                  style="color: rgb(0, 0, 0);"><span>1</span></span></ne-oli-i>
                                  <ne-oli-c class="ne-oli-content" id="u26afd27e" data-lake-id="u26afd27e">
                                      <ne-text id="uea65cc28" ne-bold="true" style="color: rgb(0, 0, 0);">聊天室福袋:</ne-text>
                                      <ne-text id="uade005fc" style="color: rgb(0, 0, 0);">1.0数量-0.5数量-0.2数量,
                                          5.0数量超过10个后, 从0开始计数; 出5.0后,数量重置为0。
                                      </ne-text>
                                      <span class="ne-viewer-b-filler" ne-filler="block"><br></span></ne-oli-c>
                              </ne-oli>
                              <ne-oli index-type="0">
                                  <ne-oli-i><span class="ne-list-symbol" data-type="0" data-level="0"
                                                  style="color: rgb(0, 0, 0);"><span>2</span></span></ne-oli-i>
                                  <ne-oli-c class="ne-oli-content" id="u28a854b3" data-lake-id="u28a854b3">
                                      <ne-text id="u36ff5f3e" ne-bold="true" style="color: rgb(0, 0, 0);">航海金宝箱:</ne-text>
                                      <ne-text id="u9470494e" style="color: rgb(0, 0, 0);">500-300-50-10(飘屏总人民价值,单位千元), 2000出之后数据重置</ne-text>
                                      <span class="ne-viewer-b-filler" ne-filler="block"><br></span></ne-oli-c>
                              </ne-oli>
                              <ne-oli index-type="0">
                                <ne-oli-i><span class="ne-list-symbol" data-type="0" data-level="0"
                                                style="color: rgb(0, 0, 0);"><span>3</span></span></ne-oli-i>
                                <ne-oli-c class="ne-oli-content" id="u28a854b3" data-lake-id="u28a854b3">
                                  <ne-text id="u36ff5f3e" ne-bold="true" style="color: rgb(0, 0, 0);">航海银宝箱:</ne-text>
                                  <ne-text id="u9470494e" style="color: rgb(0, 0, 0);">100-10(飘屏总人民价值,单位千元), 200出之后数据重置</ne-text>
                                  <span class="ne-viewer-b-filler" ne-filler="block"><br></span></ne-oli-c>
                              </ne-oli>

                              <ne-oli index-type="0">
                                <ne-oli-i><span class="ne-list-symbol" data-type="0" data-level="0"><span>4</span></span>
                                </ne-oli-i>
                                <ne-oli-c class="ne-oli-content" id="ud42ae12e" data-lake-id="ud42ae12e">
                                  <ne-text id="ua05cf6fe" ne-bold="true" style="color: rgb(0, 0, 0);display:flex;"><ClipbordComponent :show-content="true" btn-text="QQ群号" :text="1031191163" show-copy-button="true"/></ne-text>
                                  <span class="ne-viewer-b-filler" ne-filler="block"><br></span></ne-oli-c>
                              </ne-oli>
                          </div>
                          <div class="ne-inner-overlay-container">
                              <ne-overlay-tmp contenteditable="false" data-event-boundary="overlay">
                                  <div class="count-tips-module_tipsContainer___5agc"></div>
                              </ne-overlay-tmp>
                          </div>
                      </div>
                      <div style="height: 0px; overflow: hidden;"></div>
                  </div>
              </div>
          </div>
        </article>
      </van-tab>
      <van-tab name="query" ic title="数据查询" badge="新">
        <van-dropdown-menu>
          <van-dropdown-item v-model="queryType" :options="queryOptions"/>
          <van-dropdown-item v-model="sceneTye" :options="sceneOptions" />
        </van-dropdown-menu>
        <van-search v-if="queryType==='gift'"
            v-model="searchKeyword"
            show-action
            placeholder="请输入礼物名称或价值"
                    @search="doQueryData">
          <template #action>
            <van-button type="primary" size="small" @click="doQueryData">搜索</van-button>
          </template>
        </van-search>
        <ul v-if="user.maxtMemberAuth && (user.maxtMemberAuth.memberType === 'Silver' || user.maxtMemberAuth.memberType === 'Bronze')">
          <li class="gift-record" v-for="(record,index) in pageData.items" :key="index">
            <div class="gift-user" v-if="queryType==='gift'">{{record.user}}</div>
            <div class="gift-time">{{record.time}}</div>
            <div class="gift-name" v-if="queryType==='gift'">{{record.giftName}}<template v-if="record.val">({{record.val}})</template>x{{record.num}}</div>
            <div class="gift-scene" v-if="queryType==='history'">{{sceneMap[record.scenne]}}</div>
            <div class="gift-data" v-if="queryType==='history'">{{record.msg}}</div>
          </li>
        </ul>
        <div v-else>
          <p class="van-color-danger">数据查询功能为白银会员专享<router-link to="/pay">
            <van-button size="small" type="danger">购买会员</van-button>
          </router-link></p>
        </div>

        <van-pagination v-model="currentPage" :show-page-size="3"
                        force-ellipses :total-items="pageData.totalCount"
                        :items-per-page="pageData.pageSize" />
      </van-tab>
    </van-tabs>
</template>

<style lang="less">
@import "@/app.less";

.data-cnt{
  --van-badge-background: @color2;
}

.article-content{
    text-align: left;
}

[ne-bold]{
    font-weight: 700;
}
ne-oli-i .ne-list-symbol {
    padding-right: 6px;
    font-family: @font;
}

ne-oli, ne-tli, ne-uli {
    display: flex;
    justify-content: flex-start;
    align-items: baseline;
    padding-left: 2em;
}

ne-oli-i, ne-tli-i, ne-uli-i {
    min-width: 2em;
    margin-left: -2em;
    text-indent: 0;
    padding-left: 0;
    display: inline-flex;
    justify-content: flex-end;
    -moz-user-select: none;
    user-select: none;
    -webkit-user-select: none;
    box-sizing: border-box;
    white-space: nowrap;
}

ne-oli-i .ne-list-symbol:after {
    content: ".";
}

ne-oli-c, ne-tli-c, ne-uli-c {
    text-indent: 0;
    padding-left: 0;
    min-width: 1px;
}

.ne-paragraph-spacing-relax.ne-typography-classic ne-oli, .ne-paragraph-spacing-relax.ne-typography-classic ne-tli, .ne-paragraph-spacing-relax.ne-typography-classic ne-uli {
    margin-bottom: 3.915px;
}


.data-cnt{
  --van-pagination-item-default-color: @color11;

  .van-cell__title{
    width: 6rem;
    color: @black1;
  }

  .van-field__control{
    color: #666;
  }
  .gift-record{
    display: flex;
    justify-content: flex-start;
    align-items: center;
    align-content: center;
    flex-wrap: nowrap;
    flex-direction: row;
    padding: 0.2rem 1rem;
    .gift-time{
      width: 9rem;
      padding: 0 0.5rem;
      color: #666;
      white-space: nowrap;
    }

    .gift-scene{
      padding: 0 0.5rem;
      width: 4rem;
      white-space: nowrap;
    }

    .gift-user{
      width: 3rem;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }

    .gift-name,.gift-scene{
      color: @color11;
    }
  }

  .van-color-danger{
    display: flex;
    justify-content: center;
    align-content: center;
    align-items: center;
  }
  .van-pagination__item{
    color: @black1;
  }
  .van-pagination__item--active{
    color: @white;
  }
}


</style>
<script>
import {Button, showToast} from "vant";
import store from "@/store";
import {onMounted, ref, watch} from "vue";
import ClipbordComponent from "@/components/Clipbord.vue";
import API from "@/api";

const giftSceneOptions = [
  {text: "聊天室福袋", value:"福袋"},
  {text: "家族飘屏", value:"家族"},
  {text: "金宝箱", value:"金宝箱"},
  {text: "银宝箱", value:"银宝箱"},
  {text: "铜宝箱", value:"铜宝箱"},
];

const historySceneOptions = [
  {text: "聊天室福袋-5.0", value:"福袋-5.0", getShowText:(str) => str},
  {text: "金宝箱", value:"金宝箱", getShowText:(str) => str},
  {text: "银宝箱", value:"银宝箱", getShowText:(str) => str},
];

const sceneMap = {
  "福袋-5.0":"福袋-5.0",
  "金宝箱":"金宝箱",
  "银宝箱":"银宝箱"
};

export default {
    name: 'TaQuDataDesc',
    components: {ClipbordComponent, Button},
    setup(){
        const userStore = store.userStore();
        const deviceId = store.userStore().getDeviceId();
        const showDownloadQRC = ref(false);

        const tabActive = ref("desc");
        const queryOptions = [
            {text: "礼物记录", value:"gift"},
            {text: "统计结果", value:"history"},
        ];
        const sceneOptions = ref(giftSceneOptions);
        const queryType = ref("gift");
        const sceneTye = ref("福袋");
        const searchKeyword = ref("");
        const pageData = ref({items:[], totalCount:0, pageSize: 20});

        const currentPage = ref(1);

        const doQueryGift = async (value) => {
          const res = await API.data.queryGift({
            deviceId: userStore.getDeviceId(),
            scene: sceneTye.value,
            dataType: 'taqu',
            giftName: searchKeyword.value,
            pageNo: currentPage.value
          });

          if(res.success){
            pageData.value = res.data;
          }else{
            showToast(res.errorMsg);
          }
        };

        const doQueryHistory = async (value) => {
          const res = await API.data.queryHistory({
            deviceId: userStore.getDeviceId(),
            scene: sceneTye.value,
            dataType: 'taqu',
            pageNo: currentPage.value
          });

          if(res.success){
            pageData.value = res.data;
          }else{
            showToast(res.errorMsg);
          }
        };

        const doQueryData = () => {
          if(queryType.value === "gift"){
            doQueryGift()
          }else{
            doQueryHistory()
          }
        };

      onMounted(() => {
        watch(queryType, (value) => {
          if(value === "gift"){
            sceneOptions.value = giftSceneOptions;
            sceneTye.value = "福袋";
          }else{
            sceneOptions.value = historySceneOptions;
            sceneTye.value = "福袋-5.0";
          }
        });

        watch(queryType, (value) => {
          if(value === "gift"){
            sceneOptions.value = giftSceneOptions;
            sceneTye.value = "福袋";
          }else{
            sceneOptions.value = historySceneOptions;
            sceneTye.value = "福袋-5.0";
          }
        });


        watch([queryType,sceneTye,searchKeyword], () => {
          doQueryData();
        });

        watch(tabActive,() => {
          doQueryData();
        })

        watch(currentPage, () => {
          doQueryData();
        })

      });
      return {
          deviceId,
          showDownloadQRC,
          tabActive,
          queryOptions,
          sceneOptions,
          queryType,
          sceneTye,
          searchKeyword,
          pageData,
          currentPage,
          sceneMap,
          doQueryData,
          user: userStore.user,
        }
    }
}
</script>
